import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
import utils from '../../utils/utils'
/* --------------------------------------------- */
import '../../styles/components/Timer.scss'
import { TimerContainer } from './style'
/* --------------------------------------------- */
/**
 * When: To find diff between 2 days.
 * It: Finds diff between 2 days.
 */
const diffYMDHMS = (date1, date2) => {
  const years = date1.diff(date2, 'years')
  date2.add(years, 'years')

  const months = date1.diff(date2, 'months')
  date2.add(months, 'months')

  const days = date1.diff(date2, 'days')
  date2.add(days, 'days')

  const hours = date1.diff(date2, 'hours')
  date2.add(hours, 'hours')

  const minutes = date1.diff(date2, 'minutes')
  date2.add(minutes, 'minutes')

  const seconds = date1.diff(date2, 'seconds')
  date2.add(seconds, 'seconds')
  return { years, months, days, hours, minutes, seconds }
}
/* --------------------------------------------- */
// Timer component to handle timers for live events
const Timer = ({ timeLeft, metaTheme, appMessages, onNowChangeHandler }) => {
  const [time, setTime] = useState('')
  const [isLive, setIsLive] = useState(false)

  /* --------------------------------------------- */
  /**
   * It: Updates live timer.
   */
  useEffect(() => {
    const isLive = moment().isAfter(utils.convertUTCtoRelativeTimezone(timeLeft))
    setIsLive(isLive)
    let timerInterval = null
    const updateTime = () => {
      const {
        details_days: detailsDays = '', details_day: detailsDay = '',
        details_hours: detailsHours = '', details_hour: detailsHour = '',
        details_minutes: detailsMinutes = '', details_minute: detailsMinute = '',
        details_seconds: detailsSeconds = '', details_second: detailsSecond = ''
      } = appMessages
      /* --------------------------------------------- */
      const t = diffYMDHMS(moment(utils.convertUTCtoRelativeTimezone(timeLeft)), moment())
      const days = `${t.days} ${(t.days > 1) ? `${detailsDays}` : `${detailsDay}`}`
      const hours = `${t.hours} ${(t.hours > 1) ? `${detailsHours}` : `${detailsHour}`}`
      const minutes = `${t.minutes} ${(t.minutes > 1) ? `${detailsMinutes}` : `${detailsMinute}`}`
      const seconds = `${t.seconds} ${(t.seconds > 1) ? `${detailsSeconds}` : `${detailsSecond}`}`

      if (t.days === 0 && t.hours === 0 && t.minutes === 0 && t.seconds === 0) {
        setIsLive(true)
        onNowChangeHandler()
        clearInterval(timerInterval)
      } else {
        setTime(!(t.days === 0 && t.hours === 0 && t.minutes === 0) ? `${days} : ${hours} : ${minutes}` : `${seconds}`)
      }
    }
    /* --------------------------------------------- */
    if (!isLive) {
      updateTime()
      timerInterval = setInterval(updateTime, 1000)
    }
    return () => {
      clearInterval(timerInterval)
    }
  }, [appMessages, timeLeft, onNowChangeHandler])
  /* --------------------------------------------- */
  return (
    <>
      <TimerContainer {...{ metaTheme, isLive }} className='timer'>
        {isLive && 'On Now'}
        {!isLive && time}
      </TimerContainer>
    </>
  )
}


/* --------------------------------------------- */
Timer.propTypes = {
  /** UTC time in milliseconds. */
  timeLeft: PropTypes.number,
  /** Theme object. */
  theme: PropTypes.object,
  /** appMessages from contentful. */
  appMessages: PropTypes.object,
  /** on change handler. */
  onNowChangeHandler: PropTypes.func
}
/* --------------------------------------------- */
Timer.defaultProps = {
  timeLeft: 0,
  theme: {},
  appMessages: {},
  onNowChangeHandler: () => { }
}
/* --------------------------------------------- */
const mapStateToProps = state => {
  return {
    appMessages: state.appConfigReducers.appMessages
  }
}
/* --------------------------------------------- */
export default connect(mapStateToProps, null)(Timer)
  /* --------------------------------------------- */
